import React from 'react';
import { sessionUsername, WaitUntilLoggedIn } from '../Core/LoginManager';
import { restUrl } from '../../env';
import axios from 'axios';

export default class LobbyUserStatsPanel extends React.Component
{
  state = {
    activeSectionIndex: 0,

    userID: null,
    totalGamesPlayed: 0,
    last100GamesWon: 0,
    last100NumPlayedGames: 0,
    karmaGamesCompleted: 0,
    karmaNumGames: 0,

    last100PlayedGames: null
  };

  // Flag to prevent duplicate initialization in React Strict Mode
  isInitialized = false;

  async componentDidMount()
  {
    // Prevent duplicate initialization in React Strict Mode
    if( this.isInitialized )
    {
      return;
    }
    this.isInitialized = true;

    await WaitUntilLoggedIn( async () =>
    {
      await this.fetchProfileOverviewData();
    } );
  }

  async fetchProfileOverviewData()
  {
    const response = await axios.post( `${restUrl}/profile-overview`, { username: sessionUsername } );

    if( !response || !response.data )
    {
      return;
    }

    this.setState( {
      userID: response.data.userID,
      totalGamesPlayed: response.data.totalGamesPlayed,
      last100GamesWon: response.data.last100GamesWon,
      last100NumPlayedGames: response.data.last100PlayedGames,
      karmaGamesCompleted: response.data.karmaGamesCompleted,
      karmaNumGames: response.data.karmaNumGames
    } );
  }

  render()
  {
    let {
      totalGamesPlayed,
      last100GamesWon,
      last100NumPlayedGames,
      karmaGamesCompleted,
      karmaNumGames
    } = this.state;

    return (
      <>
        <img className="lobby-profile-summary-avatar" src={ process.env.PUBLIC_URL + '/avatars/meeple-ui-circle-player-white.png' } alt="Avatar icon" />

        <div className='lobby-profile-summary-username'>{ sessionUsername }</div>

        <div className="lobby-profile-summary-stat-row lobby-profile-summary-total-games colour-dark-accent-bg">
          <span className='lobby-profile-summary-stat-row-name'>Total Games</span><span className='lobby-profile-summary-stat-row-value'>{ totalGamesPlayed }</span>
        </div>
        <div className="lobby-profile-summary-stat-row lobby-profile-summary-wins colour-dark-accent-bg">
          <span className='lobby-profile-summary-stat-row-name'>Wins</span><span className='lobby-profile-summary-stat-row-value'>{ last100GamesWon }/{ last100NumPlayedGames }</span>
        </div>
        <div className="lobby-profile-summary-stat-row lobby-profile-summary-karma colour-dark-accent-bg">
          <span className='lobby-profile-summary-stat-row-name'>Karma</span><span className='lobby-profile-summary-stat-row-value'>{ karmaGamesCompleted }/{ karmaNumGames }</span>
        </div>
      </>
    );
  }
};
